import Vue from 'vue'
import App from './App.vue'
import router from './router'
import '@/assets/main.scss'
import elementUi from 'd-element-ui'
import 'qdll-business/lib/style.css'
import IndexPage from '@/components/componentWap/IndexPage.vue'

Vue.config.productionTip = false
Vue.prototype.$jump = function(path: string) {
    const ntwId = this.$route.params.ntwId || localStorage.getItem('ntwId') || -1
    this.$router.push(`/${ntwId}${path}`)
}
Vue.prototype.$isWap = false
if (/Mobi|Android|iPhone/i.test(navigator.userAgent)) {
    // 当前设备是移动设备
    Vue.prototype.$isWap = document.body.clientWidth <= 767
}
console.log(Vue.prototype.$isWap, 'Vue.prototype.$isWap')
Vue.prototype.$isLogin = localStorage.getItem('token')
Vue.use(elementUi)
Vue.component('index-wap-page', IndexPage)
new Vue({
    router,
    render: h => h(App)
}).$mount('#app')
